import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserModel } from 'src/app/modules/auth/_models/user.model';
import { AuthService } from 'src/app/modules/auth/_services/auth.service';
import { DynamicAsideMenuConfig } from '../../configs/dynamic-aside-menu.config';

const emptyMenuConfig = {
  items: []
};

@Injectable({
  providedIn: 'root'
})
export class DynamicAsideMenuService {
  private menuConfigSubject = new BehaviorSubject<any>(emptyMenuConfig);
  items : {items:any[]} ={items:[]};
  user: UserModel;

  menuConfig$: Observable<any>;
  constructor( private auth: AuthService) {
    this.user = this.auth.currentUserSubject.value;
    this.menuConfig$ = this.menuConfigSubject.asObservable();
    
    DynamicAsideMenuConfig.items.forEach(element => {
      // if (this.user.roles.includes(element.permission)) {
      //   this.items.push(element);
      // }
      
      if (element.permission) {
        if (this.user.roles.some(r=> element.permission.includes(r.toString()))) {
          this.items.items.push(element);
        }
      }
      
    });
    this.loadMenu();
  }

  // Here you able to load your menu from server/data-base/localStorage
  // Default => from DynamicAsideMenuConfig
  private loadMenu() {
    this.setMenu(this.items);
  }

  private setMenu(menuConfig) {
    this.menuConfigSubject.next(menuConfig);
  }

  private getMenu(): any {
    return this.menuConfigSubject.value;
  }
  
 
}
